// @flow
import {
    CLEAR_PLAYLIST,
    CLEAR_PLAYLIST_TO_GO_BACK,
    MARK_ITEM_AS_DOWNLOADING,
    SET_FAVOURITE_PLAYLIST,
    SET_PLAYLIST,
    SET_PLAYLIST_TO_GO_BACK,
    UPDATE_AVAILABLE_OFFLINE_FAILED,
    UPDATE_AVAILABLE_OFFLINE_START,
    UPDATE_AVAILABLE_OFFLINE_SUCCESS
} from '../actions/playlist';

import type { Action } from './types';

const initialState = {
    isDownloadedSetted: false,
    isSettingDownloaded: false,
    playlistToGoBack: false,

};

function markItemAsDownloading( id, isDownloading, playlist ) {

    playlist.tabs.map( tab => {
        tab.files.map( file => {
            if ( Number( id ) === Number( file.id ) ) {
                file.isDownloading = isDownloading;
            }
            return null;
        } );
        return null;
    } );
    return playlist;
}

//Reducer that manages a playlist
export default function playlist( state = initialState, action: Action ) {
    switch ( action.type ) {
        case SET_PLAYLIST:
            //Action that adds a download into the queue.
            return { ...state, ...action.playlist, isDownloadedSetted: false, isSettingDownloaded: false };
        case UPDATE_AVAILABLE_OFFLINE_START:
            return { ...state, isDownloadedSetted: false, isSettingDownloaded: true };
        case UPDATE_AVAILABLE_OFFLINE_SUCCESS:
            const tabs = action.result;
            return { ...state, tabs: tabs, isDownloadedSetted: true, isSettingDownloaded: false };
        case UPDATE_AVAILABLE_OFFLINE_FAILED:
            return { ...state, isDownloadedSetted: true, isSettingDownloaded: false };
        case MARK_ITEM_AS_DOWNLOADING:
            return { ...state, ...markItemAsDownloading( action.id, action.isDownloading, action.playlist ) };
        case SET_FAVOURITE_PLAYLIST:
            return { ...state, isFav: action.isFav };
        case CLEAR_PLAYLIST:
            return { ...initialState };
        case SET_PLAYLIST_TO_GO_BACK:
            return { ...state, playlistToGoBack: action.playlist };
        case CLEAR_PLAYLIST_TO_GO_BACK:
            return { ...state, playlistToGoBack: false };

        default:
            return state;
    }
}